import { useState, useEffect } from 'react';

/**
 * Hook to detect if the user is on a touch-enabled device
 * 
 * @returns {boolean} true if touch is supported, false otherwise
 */
function useTouchDetection(): boolean {
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    // Check for touch events support
    const checkTouchSupport = () => {
      const touchSupported = 'ontouchstart' in window || 
                            navigator.maxTouchPoints > 0 || 
                            (navigator as any).msMaxTouchPoints > 0;

      // More reliable pointer detection
      const coarsePointer = window.matchMedia?.('(pointer: coarse)')?.matches;
      const anyPointer = window.matchMedia?.('(any-pointer: coarse)')?.matches;

      return touchSupported || coarsePointer || anyPointer;
    };

    // Handler for touch events
    const handleTouch = () => {
      setIsTouchDevice(true);
      document.removeEventListener('touchstart', handleTouch);
    };

    // Initial check
    setIsTouchDevice(checkTouchSupport());

    // Fallback event listener in case initial check fails
    document.addEventListener('touchstart', handleTouch, { passive: true });

    return () => {
      document.removeEventListener('touchstart', handleTouch);
    };
  }, []);

  return isTouchDevice;
}

export default useTouchDetection;
